// extracted by mini-css-extract-plugin
export default {"wrapper":"BotMessage_wrapper__p1qWH","avatar":"BotMessage_avatar__tq6np","modal":"BotMessage_modal__GlVG6"};